<template>
	<div class="w-full flex flex-col divide-y divide-gray-200 dark:divide-gray-800">
		<slot/>
	</div>
</template>
<script setup lang="ts"></script>
